import React from 'react';
import RecommendedHotelCard from '@/app/components/hotel-detail/RecommendedHotelCard';

export type MemSearchProductDataWithDistance = {
  distanceToHotel: number;
  distanceText: string;
} & MemSearchProductData;

type RecommendedHotelsListProps = {
  accommodationOnly: boolean;
  businessProfileId?: string;
  hotelCardCss?: string;
  hotels: MemSearchProductDataWithDistance[] | MemSearchProductData[];
  locale: string;
  priceType: PriceType;
  taxesIncludedInPrice: boolean;
  passengers: number;
  isDoublePriceDP: boolean;
  isDoublePrice: boolean;
  onHotelCardClick?: (event: React.SyntheticEvent, data: RecommendedHotelData, cardNumber: number) => void;
};

export type RecommendedHotelData = {
  age: number;
  accommodationOnly: boolean;
  accommodationType: string;
  businessProfileId?: string;
  checkin: string;
  checkout: string;
  city: string;
  datefrom: string;
  dateto: string;
  departureAirport?: string;
  destinationCityId: number;
  internalHotelId: number;
  mealPlan: number;
  name: string;
  price: number;
};

export const mealPlanKeys: { [key: number]: string } = {
  1: 'vacation.common.mealplantype.onlybed',
  2: 'vacation.common.mealplantype.bedandbreakfast',
  3: 'vacation.common.mealplantype.halfboard',
  4: 'vacation.common.mealplantype.fullboard',
  5: 'vacation.common.mealplantype.allinclusive',
};

export function RecommendedHotelsList(props: RecommendedHotelsListProps) {
  const {
    hotels,
    accommodationOnly,
    businessProfileId,
    locale,
    onHotelCardClick,
    hotelCardCss,
    priceType,
    passengers,
    taxesIncludedInPrice,
    isDoublePriceDP,
    isDoublePrice,
  } = props;
  const hasLongPrice = hotels?.some((hotel) => hotel.price >= 1000);
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {hotels?.map((hotel, i) => {
        const {
          accomodation_meal_plan: mealPlan,
          accomodation_type: accommodationType,
          age,
          cancellation,
          city_name: cityName,
          hotel_image: hotelImage,
          hotel_name: name,
          internal_id_city: destinationCityId,
          internal_id_hotel: internalHotelId,
          origin_ap: departureAirport,
          price_original_total: price,
          price_before_discount_total: strikeThroughPrice,
          rating,
          reviews_num: reviewsNum,
          rooms_count: roomsIncludedInPrice,
          stars,
          taxes_total: cityTaxes,
          tsh,
          datefrom,
          dateto,
        } = hotel;
        const distanceText = (hotel as MemSearchProductDataWithDistance)?.distanceText;
        const hotelCheckin = hotel?.checkin?.split('-').join(''); // from yyyy-MM-dd to yyyyMMdd
        const hotelCheckout = hotel?.checkout?.split('-').join('');

        return (
          <RecommendedHotelCard
            category={stars}
            checkin={hotelCheckin}
            checkout={hotelCheckout}
            city={cityName}
            cityTaxes={cityTaxes}
            image={hotelImage}
            isCancellable={cancellation}
            isTopSecret={tsh}
            key={internalHotelId}
            flightIncluded={!accommodationOnly}
            locale={locale}
            mealPlanKey={mealPlanKeys[mealPlan]}
            name={name}
            passengers={passengers}
            priceType={priceType}
            price={price}
            reviewsScore={rating}
            reviews={reviewsNum}
            reviewSource={hotel.rating_source}
            roomsIncludedInPrice={roomsIncludedInPrice}
            strikeThroughPrice={strikeThroughPrice}
            onClick={(event: React.SyntheticEvent) =>
              onHotelCardClick &&
              onHotelCardClick(
                event,
                {
                  accommodationOnly,
                  accommodationType,
                  age,
                  businessProfileId,
                  checkin: hotelCheckin,
                  checkout: hotelCheckout,
                  city: cityName,
                  datefrom,
                  dateto,
                  departureAirport,
                  destinationCityId,
                  internalHotelId,
                  mealPlan,
                  name,
                  price,
                },
                i + 1
              )
            }
            css={hotelCardCss}
            tabIndex={0}
            role="button"
            isDoublePrice={isDoublePrice}
            isDoublePriceDP={isDoublePriceDP}
            taxesIncludedInPrice={taxesIncludedInPrice}
            distanceText={distanceText}
            hasLongPrice={hasLongPrice}
          />
        );
      })}
    </>
  );
}
